import type { GlobalState } from '../types/globalState';
import type { CustomerOrder } from '../../api/services/customer';

export function selectCustomerOrders(global: GlobalState, customerId: string): CustomerOrder[] {
  return global.customerOrders.byCustomerId[customerId]?.orders || [];
}

export function selectCustomerOrdersLoading(global: GlobalState, customerId: string): boolean {
  return global.customerOrders.byCustomerId[customerId]?.isLoading || false;
}

export function selectCustomerOrdersLastUpdated(global: GlobalState, customerId: string): number | undefined {
  return global.customerOrders.byCustomerId[customerId]?.lastUpdated;
}

export function selectSelectedOrderId(global: GlobalState): string | undefined {
  return global.customerOrders.selectedOrderId;
}

export function selectOrderById(global: GlobalState, customerId: string, orderId: string): CustomerOrder | undefined {
  const orders = selectCustomerOrders(global, customerId);
  return orders.find(order => order.id === orderId);
}

export function selectCurrentCustomerId(global: GlobalState): string | undefined {
  return global.customerOrders.currentCustomerId;
}

export function selectCurrentCustomerData(global: GlobalState) {
  return global.customerOrders.customerData;
} 